import type { ICatalog } from '@platform/core/types';
import { useLabel } from '@platform/hooks/useLabel';
import { catalogLabel, moduleNav, navGroup } from '@platform/navigation';

/**
 * Підпис категорії модуля в «Встановлених модулях», як його показує прототип (cat модуля після shapeModules0 і підпис словника): група
 * верхнього меню модуля, інакше категорія каталогу простору, інакше ключ.
 */
export function useModuleCategory(catalog: ICatalog | undefined): (moduleKey: string, key: string) => string {
  const label = useLabel();
  return (moduleKey, key) => {
    const group = navGroup(moduleNav(moduleKey).group);
    return (group && label(catalogLabel(group))) || label(catalog?.categories.find((c) => c.key === key)?.name) || key;
  };
}
